module.exports = __webpack_public_path__ + "src/assets/img/bg-box01.cb86dcfc.png";